// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"9f00fb07","277":"ecbbfb63","574":"0be30de2","610":"ecbbfb63"}[chunkId] + ".chunk.css";
};